import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDone, fetchStart, fetchError as fetchErrorAction } from '../actions/fetch.actions';
import { resourceAdd } from '../actions/resources.actions';
import { setFormValuesRecursive } from '../lib/form.utils';
import { FORMS_ENGINE_FORM_RESOURCE } from '../resources/forms.engine.form.resource';
import { currentUserSelector } from '../selectors/auth.selectors';
import {
  fetchedSelector,
  fetchErrorSelector,
  fetchingSelector,
  shouldFetchSelector
} from '../selectors/fetch.selectors';
import { resourceStateSelector } from '../selectors/resources.selectors';
import formsService from '../services/api/forms.service';

const resource = FORMS_ENGINE_FORM_RESOURCE;

export const useFormsEngineHook = (slug, options = {}) => {
  const dispatch = useDispatch();
  const user = useSelector(currentUserSelector);
  const fetchError = useSelector((state) => fetchErrorSelector(state, { resource }));
  const fetching = useSelector((state) => fetchingSelector(state, { resource }));
  const fetched = useSelector((state) => fetchedSelector(state, { resource }));
  const shouldFetch = useSelector((state) => shouldFetchSelector(state, { resource }));
  const formState = useSelector((state) => resourceStateSelector(state, { resource }));

  useEffect(() => {
    if (!slug || !shouldFetch) {
      return;
    }

    const formData = { ...(formState?.data ?? {}), ...(options?.prefillData ?? {}) };
    dispatch(fetchStart(resource));
    formsService.getBySlug(slug, {
      onSuccess: (resp) => {
        const jsonData = resp.json;
        if (_.get(jsonData, 'template.content.fields', []).length) {
          setFormValuesRecursive(
            _.get(jsonData, 'template.content.fields', []),
            options?.prefillConfig ?? {},
            user,
            formData,
            false
          );
        }
        if (_.get(jsonData, 'template.content.steps', []).length) {
          setFormValuesRecursive(
            _.get(jsonData, 'template.content.steps', []),
            options?.prefillConfig ?? {},
            user,
            formData,
            true
          );
        }
        dispatch(resourceAdd(resource, { jsonData: jsonData || {}, data: formData }));
        dispatch(fetchDone(resource));
      },
      onError: (message) => {
        dispatch(fetchErrorAction(resource, message));
      }
    });
  }, [formState?.data, dispatch, options.prefillConfig, shouldFetch, slug, options.prefillData, user]);

  return { data: formState?.data ?? {}, jsonData: formState?.jsonData ?? {}, fetchError, fetching, fetched };
};
